import termsAndConditionsPdfFile from '@/assets/pdfs/Curby Terms and Conditions.pdf';
import { StandardButton } from '@/components/buttons/standard';
import { ContentPanel } from '@/components/content-panel';
import { Logo } from '@/components/logo';
import { PrimaryLayout } from '@/layouts/primary';
import { Box, Flex, Text, Title } from '@mantine/core';
import { useNavigate } from '@tanstack/react-router';
import { createRef, useEffect, useMemo, useState } from 'react';
import { CurbyImage } from './curby-image';
import styles from './styles.module.css';

export const TermsPage = () => {
	const navigate = useNavigate();
	const [downloaded, setDownloaded] = useState(false);
	const anchorRef = createRef<HTMLAnchorElement>();

	/** Download PDF on page load */
	useEffect(() => {
		if (!downloaded) {
			anchorRef.current?.click?.();
			setDownloaded(true);
		}
	}, [downloaded, anchorRef]);

	const goToSignUpButton = useMemo(
		() => (
			<StandardButton key={1} variant="filled" onClick={() => navigate({ to: '/signup' })}>
				Sign Up
			</StandardButton>
		),
		[navigate]
	);

	return (
		<PrimaryLayout footer={{ children: [goToSignUpButton] }}>
			<Flex direction="column" align="center" justify="flex-start" h="100%" bg="white" flex={1}>
				<Flex
					direction="column"
					align="center"
					justify="flex-start"
					h="221px"
					className={styles.splash}
					pt="lg"
				>
					<Logo />
					<Box h="50px" />
					<Title order={1}>Terms & Conditions</Title>
				</Flex>
				<ContentPanel>
					<CurbyImage />
					<Flex direction="column" gap={20} align="center">
						<Text size="md" ta="center">
							If the terms and conditions document is not loading, please click the button below to
							download the PDF.
						</Text>
						<a ref={anchorRef} href={termsAndConditionsPdfFile} download>
							Download Terms and Conditions
						</a>
					</Flex>
				</ContentPanel>
			</Flex>
		</PrimaryLayout>
	);
};
